/* eslint-disable quotes */
import { HOSTNAME } from '@/utils'

export const jsonLdLogin = (_data, locale) => {
  const schema = {
    "@context": "http://schema.org",
    "@type": "WebPage",
    "name": "Login Page",
    "description": "Login to access your account and enjoy personalized features.",
    "url": `https://${HOSTNAME}/${locale}/login`,
    "potentialAction": {
      "@type": "ViewAction",
      "target": `https://${HOSTNAME}/${locale}/login`,
      "name": "Login"
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": `https://${HOSTNAME}/${locale}`
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Login Page",
          "item": `https://${HOSTNAME}/${locale}/login`
        }
      ]
    }
  }

  return JSON.stringify(schema)
}
